import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { KoConfigWorkspace, KoRuleDTO } from '../tokens/ko-config.token';
import { API_PATHS } from '../config/api-paths';

/**
 * REST-only implementation of `KoConfigWorkspace` (EM-135 Master Admin KO Config).
 *
 * Calls /services/embedded/api/ko-rules via HttpClient.
 * Rule 07 / Rule 10 — no mock fallback. Playwright tests intercept via `page.route()`.
 *
 * Authority required: ROLE_MASTER_ADMIN (enforced server-side and by roleGuard on the route).
 */
/** Far above the registry's size (30 rules today); Spring's own max page size is 2000. */
const KO_RULES_PAGE_SIZE = 500;

@Injectable()
export class KoConfigRestService implements KoConfigWorkspace {
  private readonly http = inject(HttpClient);

  /**
   * EM-1867 — `GET /api/ko-rules` is the generated, PAGEABLE CRUD list: without an explicit `size` Spring
   * serves only its default page of 20, in no guaranteed order. The registry holds 30 rules across the
   * four scopes, so ten were silently cut off (the Working-Capital tab showed 5 of 12, SDF 0 of 2) — and
   * whichever row Postgres returned last after an UPDATE (R05, once its seeded band was corrected)
   * vanished from its tab. Ask for the whole registry, in a stable order.
   */
  listKoRules(): Observable<KoRuleDTO[]> {
    return this.http.get<KoRuleDTO[]>(API_PATHS.KO_RULES, { params: { size: KO_RULES_PAGE_SIZE, sort: 'id,asc' } });
  }

  updateKoRule(id: number, payload: KoRuleDTO): Observable<KoRuleDTO> {
    return this.http.put<KoRuleDTO>(`${API_PATHS.KO_RULES}/${id}`, payload);
  }
}
